import React from 'react';
import { useEffect } from 'react';

const ListGraphicFilters = (params) => {

    useEffect(() => {        
        console.log("Filtros de gráfica cargados correctamente")      
    });

    function obtenerIconoEtiqueta(atributo){

        var icono = ""

        console.log(atributo)

        if(atributo ===  "Información general"){ icono = "analytics"; }    
        else if(atributo ===  "Meteorología"){ icono = "cloud"; }    
        else if(atributo ===  "Instalación"){ icono = "home"; }    
        else if(atributo ===  "Paneles solares"){ icono = "solar_power"; }    
        else if(atributo ===  "Baterías"){ icono = "battery_std"; }      
        else if(atributo ===  "Grupo electrógeno"){ icono = "dynamic_form"; }    
        else if(atributo ===  "Coche"){ icono = "directions_car"; } 
        else if(atributo ===  "Economía"){ icono = "euro"; } 

        return icono
    }

    const listGraphicFilters = params.objEtiquetas.map((filtro, index) =>    
        <React.Fragment key={"Etiqueta"+index}>
            {   index !== 0 ?
                <button className='button tertiary size-s' id={"Etiqueta"+index} style={{ color: params.backupColoresGrafica[index-1].color}} onClick={() => params.showHideSeries(params.chartObj,params.googleObj,[{"row":null,"column":index}])}><span className="material-icon">{obtenerIconoEtiqueta(filtro.split(" - ")[0])}</span>{filtro.split(" - ")[1]}</button>            
                :
                <></>
            }
        </React.Fragment>
    );   

    return (        
        <>        
        <p className='horizontal gap-03 wrap center size-s hAxisAnalytics' style={{opacity: 0.6}}>Pulsa etiquetas para ocultar o mostrar líneas</p>
        
        <div className='horizontal gap-03 wrap center chart-legend' >
            {listGraphicFilters}
        </div>
        </>
    );
}

export default ListGraphicFilters